module.exports = __webpack_public_path__ + "static/img/153551_3_3.a68f55d9.jpg";